document.addEventListener("DOMContentLoaded", function () {
  var headings = document.querySelectorAll(".order h2");
  var subheaders = document.querySelectorAll(".order h3");
  var total = headings.length + subheaders.length;
  if (total < 2) return;
  function findSubheaders(el, n, m = 0, res = "") {
    var nextEl = el.nextElementSibling;
    var result = res;
    if (nextEl && nextEl.tagName !== "H2") {
      var num = m;
      if (nextEl.tagName == "H3") {
        num++;
        var text = nextEl.innerText.replace(/^([0-9])+\. /g, "");
        var url = window.theme.utils.handleize(text);
        nextEl.id = url;
        result =
          result +
          `<a href="#${url}" data-id="${url}" class="internal-link-h3">${n}.${num}. ${text}</a>`;
      }
      result = findSubheaders(nextEl, n, num, result);
    }
    return result;
  }

  var wrapper = document.createElement("div");
  wrapper.id = "internal-links";
  var wrapperHTML = `
  <input type="checkbox" id="internal-links-trigger" hidden/>
  <label for="internal-links-trigger" class="relative h2 blue d-block">Table of contents</label>
  <p class="mb-0">`;
  var h2s = 0;

  headings.forEach(function (heading) {
    h2s++;
    var text = heading.innerText.replace(/^([0-9])+\. /g, "");
    var url = window.theme.utils.handleize(text);
    wrapperHTML =
      wrapperHTML +
      `<a href="#${url}" data-id="${url}" class="internal-link-h2">${h2s}. ${text}</a>`;
    heading.id = url;
    var subheaders = findSubheaders(heading, h2s);
    if (subheaders !== "") wrapperHTML = wrapperHTML + subheaders;
  });
  wrapperHTML = wrapperHTML + "</p>";
  wrapper.innerHTML = wrapperHTML;

  var firstParagraph = document.querySelector(".order p:first-child");

  while (firstParagraph.nextElementSibling.tagName === "P") {
    firstParagraph = firstParagraph.nextElementSibling;
  }

  firstParagraph = firstParagraph.nextElementSibling;

  headings[0].parentNode.insertBefore(wrapper, firstParagraph);

  var internalLinks = document.querySelectorAll("#internal-links a");
  internalLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      location.hash = e.target.dataset.id;
      var section = document.getElementById(e.target.dataset.id);
      scrollTo(0, section.offsetTop - 90);
    });
  });
});
